import { getAuthAxiosBackend } from "@/helpers/axios"

class CategoriesServices {
    get(id) {
        return getAuthAxiosBackend().get('categories/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('categories', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('categories', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('categories/' + id, data)
    }

    // restore(id, data) {
    //     return getAuthAxiosBackend().put('categories/restore/' + id, data)
    // }

    delete(id) {
        return getAuthAxiosBackend().delete('categories/softDelete/' + id.toString())
    }

    // forceDelete(id) {
    //     return getAuthAxiosBackend().delete('categories/delete/' + id.toString())
    // }
}

export default new CategoriesServices()